import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { User } from "../models/user";
import {EncryptDecryptService} from "./encrypt-decrypt.service";
import { VariablesGlobales } from './globals';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;

  constructor(private encdec: EncryptDecryptService, private http: HttpClient, public param: VariablesGlobales) {
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  logout() {
    // Supprime le user du localStorage et set l'utilisateur actuel à 'null'
    localStorage.removeItem('currentUser');
    this.param.editDossier = false;
    this.param.editJobalert = false;
    this.param.editPassword = false;
    this.param.editPasswordForced = false;
    this.param.editPj = false;
    this.param.editProfil = false;
    this.param.editReponse = false;
    this.param.editStatus = false;
    this.currentUserSubject.next(null);
  }
}

